module.exports = __webpack_public_path__ + "static/graph-default_fr-78597a4d4be4b0c1f79d46b16bb942b5.svg";